import { gql } from '@apollo/client';

export const CREATE_QUESTIONNAIRE_RESPONSE = gql`
  mutation createQuestionnaireResponse ($input: questionnaire_create_responseInput!) {
  createQuestionnaireResponse(input:$input) {
    message
    success
  }
}`;

export const CLIENT_UPDATE_BIO = gql`
  mutation clientUpdateBio($input: cfs_update_bioInput!) {
    clientUpdateBio(input: $input) {
      bio {
        id
        sex
        length
        weight
        clientId
        clientBioFemale {
          id
        }
        waistCircumference
        dateOfBirth
        isVegetarian
      }
    }
  }
`;

export const CLIENT_UPDATE_CONTACT_DETAILS = gql`
  mutation ClientUpdateContactDetails(
    $familyDetailAttributes: FamilyDetailData!
    $careerAndEducationDetailAttributes: CareerAndEducationData!
    $personalContactDetailAttributes: PersonalContactDetailData
    $caregiverContactDetailsAttributes: [CareGiverData!]!
  ) {
    clientUpdateContactDetails(
      input: {
        params: {
          familyDetailAttributes: $familyDetailAttributes
          careerAndEducationDetailAttributes: $careerAndEducationDetailAttributes
          personalContactDetailAttributes: $personalContactDetailAttributes
          caregiverContactDetailsAttributes: $caregiverContactDetailsAttributes
        }
      }
    ) {
      personalContactDetail {
        id
        createdAt
        updatedAt
        addressPlace
        addressNumber
        addressStreet
        addressCountry
        addressPostalCode
        telephoneNumber
        telephoneCountryCode
      }
    }
  }
`;

export const CLIENT_UPDATE_ALLERGIES = gql`
  mutation clientUpdateAllergies($input: cfs_update_allergiesInput!) {
    clientUpdateAllergies(input: $input) {
      allergies {
        id
        allergy {
          id
          name
        }
      }
    }
  }
`;

export const CLIENT_UPDATE_SPECIALISTS = gql`
  mutation clientUpdateSpecialists($input: cfs_update_specialistsInput!) {
    clientUpdateSpecialists(input: $input) {
      id
      specialists {
        id
        name
      }
      otherHealthProfessionals {
        id
        name
      }
    }
  }
`;

export const CLIENT_UPDATE_OTHER_MEDICATIONS = gql`
  mutation clientUpdateOtherMedications($input: cfs_update_other_medicationsInput!) {
    clientUpdateOtherMedications(input: $input) {
      otherMedication {
        id
        content
        clientId
      }
    }
  }
`;

export const CLIENT_UPDATE_VACCINATIONS = gql`
  mutation clientUpdateVaccinations($input: cfs_update_vaccinatinosInput!) {
    clientUpdateVaccinations(input: $input) {
      vaccinations {
        id
        when
        vaccination {
          id
          name
        }
      }
    }
  }
`;

export const CLIENT_UPDATE_BLOODLINE_DISEASES = gql`
  mutation clientUpdateBloodlineDiseases($input: cfs_update_bloodline_diseasesInput!) {
    clientUpdateBloodlineDiseases(input: $input) {
      bloodlineDiseases {
        id
        disease
        familyMembers
      }
    }
  }
`;

export const CLIENT_UPDATE_SURGERIES = gql`
  mutation clientUpdateSurgeries($input: cfs_update_surgeriesInput!) {
    clientUpdateSurgeries(input: $input) {
      surgeries {
        id
        forWhat
        when
      }
    }
  }
`;

export const CLIENT_UPDATE_IMPORTANT_NOTES = gql`
  mutation clientUpdateImportantNotes($input: cfs_update_important_notesInput!) {
    clientUpdateImportantNotes(input: $input) {
      importantNotesToProfessional {
        id
        note
        yearOfEvent
      }
    }
  }
`;


export const CLIENT_UPDATE_FEMALE_BIO = gql`
  mutation clientUpdateFemaleBio($input: cfs_update_female_bioInput!) {
    clientUpdateFemaleBio(input: $input) {
      id
    }
  }
`;
